module.exports = __webpack_public_path__ + "static/media/title.54cf01a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MissionFinish/NewTitles/title.png
// module id = 1742
// module chunks = 0